import React from 'react';
import { Button, Container, Row, Col, Card, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Banner from '../components/Banner';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import logo_sateco from '../assets/images/logo_sateco_bis.png';
import logo_elevage from '../assets/images/logo_elevageplus.png';
import '../styles/Home.css';

const Home = () => {
  return (
    <>
      <Banner />
      
      {/* Section Présentation GUIRETTE */}
      <section className="py-5 bg-gradient-success text-white">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <Badge bg="light" text="dark" className="mb-4 px-3 py-2 rounded-pill fw-bold">
                🚀 LA RÉFÉRENCE AGRICOLE 4.0
              </Badge>
              <h2 className="display-5 fw-bold mb-4">
                GUIRETTE : <span className="text-warning">Vos Alliés Technologiques</span> qui <span className="text-warning">Multiplient vos Bénéfices</span>
              </h2>
              <p className="lead mb-4 fs-5">
                Startup marseillaise qui révolutionne l'agriculture par le digital. 
                Nous combinons cartographie satellitaire, analyse des sols et IA vétérinaire pour 
                <strong> maximiser votre rentabilité à l'hectare et protéger votre cheptel</strong>.
              </p>
              <div className="impact-stats">
                <Row className="g-4 justify-content-center">
                  <Col md={3} sm={6}>
                    <div className="text-center">
                      <div className="h2 fw-bold text-warning mb-1">+40%</div>
                      <small>Rendement moyen</small>
                    </div>
                  </Col>
                  <Col md={3} sm={6}>
                    <div className="text-center">
                      <div className="h2 fw-bold text-warning mb-1">-30%</div>
                      <small>Réduction intrants</small>
                    </div>
                  </Col>
                  <Col md={3} sm={6}>
                    <div className="text-center">
                      <div className="h2 fw-bold text-warning mb-1">95%</div>
                      <small>Diagnostics précis</small>
                    </div>
                  </Col>
                  <Col md={3} sm={6}>
                    <div className="text-center">
                      <div className="h2 fw-bold text-warning mb-1">5min</div>
                      <small>Résultats instantanés</small>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Section SaTeCO+ */}
      <section className="py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-5 mb-lg-0">
              <div className="pe-lg-4">
                <Badge bg="success" className="mb-3 px-3 py-2 rounded-pill">
                  🌟 NOTRE TECHNOLOGIE PHARE
                </Badge>
                <div className="d-flex align-items-center mb-4">
                  <img src={logo_sateco} alt="SaTeCO+" height="80" className="me-3" />
                  <div>
                    <h2 className="h1 fw-bold text-success mb-1">SaTeCO+</h2>
                    <p className="text-muted mb-0">L'œil satellite intelligent pour votre exploitation</p>
                  </div>
                </div>
                
                <p className="lead mb-4">
                  <strong>Révolutionnez votre agriculture</strong> avec notre plateforme d'analyse satellitaire 
                  qui transforme les données brutes en <span className="text-success fw-bold">recommandations profitables</span>.
                </p>

                {/* Fonctionnalités en cartes */}
                <Row className="g-3 mb-4">
                  <Col md={6}>
                    <Card className="border-0 bg-light h-100">
                      <Card.Body className="p-3">
                        <div className="d-flex align-items-center">
                          <span className="text-success fs-4 me-3">🚀</span>
                          <div>
                            <h6 className="fw-bold mb-1">Analyse Express</h6>
                            <small className="text-muted">5-10 min après collecte</small>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="border-0 bg-light h-100">
                      <Card.Body className="p-3">
                        <div className="d-flex align-items-center">
                          <span className="text-success fs-4 me-3">📊</span>
                          <div>
                            <h6 className="fw-bold mb-1">10 Paramètres</h6>
                            <small className="text-muted">pH, NPK, carbone, texture...</small>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="border-0 bg-light h-100">
                      <Card.Body className="p-3">
                        <div className="d-flex align-items-center">
                          <span className="text-success fs-4 me-3">🎯</span>
                          <div>
                            <h6 className="fw-bold mb-1">Précision Maximale</h6>
                            <small className="text-muted">Cartes de fertilité mensuelles</small>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="border-0 bg-light h-100">
                      <Card.Body className="p-3">
                        <div className="d-flex align-items-center">
                          <span className="text-success fs-4 me-3">⚡</span>
                          <div>
                            <h6 className="fw-bold mb-1">Temps Réel</h6>
                            <small className="text-muted">Surveillance continue</small>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <div className="d-flex flex-wrap gap-2 mb-3">
                  <Button 
                    variant="success" 
                    size="lg" 
                    className="rounded-pill px-4 fw-bold"
                    as={Link}
                    to="/data"
                  >
                    📊 Voir les Données Réelles
                  </Button>
                  <Button 
                    variant="outline-success" 
                    size="lg" 
                    className="rounded-pill px-4 fw-bold"
                    as={Link}
                    to="/demo"
                  >
                    🎥 Demander une Démo
                  </Button>
                </div>

                {/* Lien d'accès direct */}
                <div className="text-center mt-4">
                  <a 
                    href="https://satecoplus.guirette.net" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-sm rounded-pill px-3"
                  >
                    🌐 Accéder à SaTeCO+
                  </a>
                </div>
              </div>
            </Col>
            
             <Col lg={6} className="mb-5 mb-lg-0">
              <div className="pe-lg-4">
                <Badge bg="primary" className="mb-3 px-3 py-2 rounded-pill">
                  🐄 NOTRE SOLUTION VÉTÉRINAIRE
                </Badge>
                <div className="d-flex align-items-center mb-4">
                  
                  <div>
                   <img src={logo_elevage} alt="SaTeCO+" height="80" className="me-3" />
                    <p className="text-muted mb-0">Diagnostic animal intelligent par IA</p>
                  </div>
                </div>
                
                <p className="lead mb-4">
                  <strong>Protégez votre cheptel</strong> avec notre plateforme de diagnostic vétérinaire 
                  qui analyse vos animaux en temps réel et fournit des 
                  <span className="text-primary fw-bold"> recommandations précises pour sauver vos bêtes</span>.
                </p>

                {/* Fonctionnalités ElevagePlus */}
                <Row className="g-3 mb-4">
                  <Col md={6}>
                    <Card className="border-0 bg-light h-100">
                      <Card.Body className="p-3">
                        <div className="d-flex align-items-center">
                          <span className="text-primary fs-4 me-3">🎥</span>
                          <div>
                            <h6 className="fw-bold mb-1">Analyse Vidéo IA</h6>
                            <small className="text-muted">Diagnostic en 5-20 secondes</small>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="border-0 bg-light h-100">
                      <Card.Body className="p-3">
                        <div className="d-flex align-items-center">
                          <span className="text-primary fs-4 me-3">⚡</span>
                          <div>
                            <h6 className="fw-bold mb-1">Résultats Instantanés</h6>
                            <small className="text-muted">2-3 minutes max</small>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="border-0 bg-light h-100">
                      <Card.Body className="p-3">
                        <div className="d-flex align-items-center">
                          <span className="text-primary fs-4 me-3">🐮</span>
                          <div>
                            <h6 className="fw-bold mb-1">Tous Animaux</h6>
                            <small className="text-muted">Bovins, ovins, volailles...</small>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="border-0 bg-light h-100">
                      <Card.Body className="p-3">
                        <div className="d-flex align-items-center">
                          <span className="text-primary fs-4 me-3">💰</span>
                          <div>
                            <h6 className="fw-bold mb-1">Économique</h6>
                            <small className="text-muted">2 analyses gratuites</small>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                <div className="d-flex flex-wrap gap-2 mb-3">
                  <Button 
                    variant="primary" 
                    size="lg" 
                    className="rounded-pill px-4 fw-bold"
                    href="https://elevageplus.guirette.net/analyze"
                    target="_blank"
                  >
                    🐮 Essayer Gratuitement
                  </Button>
                  <Button 
                    variant="outline-primary" 
                    size="lg" 
                    className="rounded-pill px-4 fw-bold"
                    href="https://elevageplus.guirette.net/register"
                    target="_blank"
                  >
                    📝 Créer un Compte
                  </Button>
                </div>

                {/* Lien d'accès direct */}
                <div className="text-center mt-4">
                  <a 
                    href="https://elevageplus.guirette.net" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-sm rounded-pill px-3"
                  >
                    🌐 Accéder à ElevagePlus
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

     

      {/* Section preuve sociale rapide */}
      <section className="py-5">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <h3 className="h2 fw-bold mb-4">
                Rejoignez les <span className="text-success">500+ Agriculteurs</span> et <span className="text-primary">Éleveurs</span> qui nous Font Confiance
              </h3>
              <Row className="g-4">
                <Col md={3} sm={6}>
                  <div className="p-3">
                    <div className="h3 fw-bold text-success mb-2">95%</div>
                    <small className="text-muted">de satisfaction client</small>
                  </div>
                </Col>
                <Col md={3} sm={6}>
                  <div className="p-3">
                    <div className="h3 fw-bold text-primary mb-2">7/7j</div>
                    <small className="text-muted">Support technique</small>
                  </div>
                </Col>
                <Col md={3} sm={6}>
                  <div className="p-3">
                    <div className="h3 fw-bold text-success mb-2">24h</div>
                    <small className="text-muted">Délai mise en service</small>
                  </div>
                </Col>
                <Col md={3} sm={6}>
                  <div className="p-3">
                    <div className="h3 fw-bold text-primary mb-2">2min</div>
                    <small className="text-muted">Diagnostic vétérinaire</small>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <WhyChooseUs />
      <Testimonials />
    </>
  );
};

export default Home;